"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
const utils_1 = require("../helpers/utils");
const P2 = building_blocks_ui_common_1.styled.p `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'P2',
    defaultFontWeight: 'P2',
    defaultLineHeight: 'P2'
})}
  `;
exports.default = P2;
//# sourceMappingURL=para-two.js.map